export const DEFAULT_CONTRACT_FEE = 350;
export const DEFAULT_TERMINATION_FEE = 50;
